export default "__VITE_ASSET__gGZ8ElDF__"